import YYInput from './input'

export default YYInput